import { Box, Divider } from '@mui/material';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Images from '../../../Configs/images';
import ROUTES from '../../../Configs/routes';
import { getUserItems } from '../../../Redux/Models/box';
import { getUserData } from '../../../Utils/storages';
import { formatNumToCurrency } from '../../../Utils/helpers';
import { getUserData as getUser } from '../../../Redux/Models/user';

export default function Component({ wallet }) {
  const userData = getUserData();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const isPinVerified = userData?.is_pin_verified;
  const navigate = useNavigate();
  const { items } = useSelector((state) => state.box);

  useEffect(() => {
    dispatch(getUserItems(userData.id));
    dispatch(getUser(userData.id));
  }, []);

  return (
    <Box display="flex" justifyContent="space-between" alignItems="center" className="owning">
      <Box display="flex" flexDirection="column" alignSelf="flex-start" flex={1} onClick={() => navigate(`${ROUTES.wallet()}${isPinVerified ? '' : '/intro'}`)}>
        <Box display="flex" alignItems="center" gap={0.5}>
          <img src={Images.MyBalance} alt="my balance" />
          <div className="s-10">{t('wallet.myBalance')}</div>
        </Box>
        <div className="weight-700 mt-1 s-12">{formatNumToCurrency(wallet?.amount) || 'Top up first'}</div>
      </Box>
      <Divider orientation="vertical" variant="middle" flexItem sx={{ borderColor: '#E5E5E5', mx: 2 }} />
      <Box display="flex" flexDirection="column" alignSelf="flex-start" flex={1} onClick={() => navigate(`${ROUTES.myStorages()}`)}>
        <Box display="flex" alignItems="center" gap={0.5}>
          <img src={Images.MyStorage} alt="my storage" />
          <div className="s-10">{t('menu.myStorage')}</div>
        </Box>
        <div className="weight-700 mt-1 s-12">
          {items.length}
          {' '}
          {t('common.item')}
        </div>
      </Box>
    </Box>
  );
}
